const CONFIGURED_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const BACKEND_URL = process.env.NODE_ENV === "production" ? "" : CONFIGURED_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const request = async (path, token) => {
  const response = await fetch(`${API}${path}`, {
    credentials: "include",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const error = new Error(body.detail || `Request failed: ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return response.json();
};

export const getLiveBriefing = async (scope, token) =>
  request(`/briefing/live?scope=${encodeURIComponent(scope || "world")}`, token);

export const searchLiveBriefing = async (query, token) =>
  request(`/briefing/search?q=${encodeURIComponent(query)}`, token);
